import { render } from "./form-part-b-trust-accounting-records.html?vue&type=template&id=677bd214&scoped=true&ts=true&external"
import script from "./form-part-b-trust-accounting-records.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-trust-accounting-records.ts?vue&type=script&lang=ts&external"

import "./form-part-b-trust-accounting-records.scss?vue&type=style&index=0&id=677bd214&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677bd214"]])

export default __exports__